import { assert, error } from '../../app/logger.js';
import { nested_list_diff } from '../../util/diff.js';
import { Pipeable } from './pipeable.js';

//
// Basic pipeline mechanism to connect a tree-like data and data processors
// such as UI.
//
class PipeableTree extends Pipeable {
  pipe(receiver) {
    this.addReceiver('self', receiver);
    if (this.data !== undefined) {
      this.notifyReceiver(
        receiver,
        this.data,
        this.computeDiff(this.constructor.DefaultValue, this.data)
      );
    }
    return this.createPipe(receiver);
  }

  notifyIfChanged(property, value, oldValue) {
    assert(
      value && 'children' in value,
      `${property} value has no 'children' property`
    );
    assert(
      oldValue && 'children' in oldValue,
      `${property} value has no 'children' property`
    );

    let diff = this.computeDiff(oldValue, value);
    if (diff.length > 0) {
      this.notify(property, value, diff);
    }
  }

  computeDiff(oldTree, newTree) {
    return this.constructor.computeDiff(oldTree, newTree);
  }

  static DefaultValue = {
    children: [],
  };

  static Diff = nested_list_diff;

  static computeDiff(oldTree, newTree) {
    if (!oldTree || !oldTree.children || !(oldTree.children instanceof Array)) {
      error(`[data] wrong old tree`, oldTree);
      return [];
    }
    if (!newTree || !newTree.children || !(newTree.children instanceof Array)) {
      error(`[data] wrong new tree`, newTree);
      return [];
    }
    return this.Diff(oldTree.children, newTree.children);
  }
}

export { PipeableTree };
